import { useTranslation } from 'react-i18next';

import type { NewlyAwardedBadge } from './badgeApi';

interface BadgeAwardAnnouncementProps {
  awards: NewlyAwardedBadge[];
  confirmed?: boolean;
}

function BadgeAwardAnnouncement({ awards, confirmed }: BadgeAwardAnnouncementProps) {
  const { t } = useTranslation();

  if (confirmed === false) {
    return (
      <p role="alert" aria-live="assertive">
        {t('exercise.badgeAwardingUnconfirmed')}
      </p>
    );
  }

  if (confirmed !== true || awards.length === 0) {
    return null;
  }

  return (
    <section role="status" aria-live="polite" aria-labelledby="badge-award-announcement-heading">
      <h2 id="badge-award-announcement-heading">{t('badges.newAwards')}</h2>
      <ul>
        {awards.map((award) => (
          <li key={award.badgeCode}>
            <img
              src={award.imageUrl}
              alt={t(`badges.catalog.${award.badgeCode}.altText`, { defaultValue: award.name })}
              width="64"
              height="64"
            />
            <span>{t(`badges.catalog.${award.badgeCode}.name`, { defaultValue: award.name })}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default BadgeAwardAnnouncement;
